// extracted by mini-css-extract-plugin
module.exports = {"Outer":"Enforcer_Outer__3dROz","Inner":"Enforcer_Inner__1mvpO"};